import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MaskHelpers } from '@app/@core/utils/mask-helpers';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[ngxInputMask]',
    standalone: false
})
export class InputMaskDirective implements AfterViewInit, OnDestroy {
  @Input() mask: string;
  @Input('control') control: FormControl;
  subscription: Subscription;
  constructor(
    private el: ElementRef<HTMLInputElement>,
    private renderer2: Renderer2,
  ) { }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit(): any {
    if (this.control) {
      this.subscription = this.control.valueChanges.pipe().subscribe(x => {
        if (x && x !== MaskHelpers.toMask(x, this.mask)) {
          this.buildMask(x, this.mask);
        }
      });
    } else {
      setTimeout(() => {
        let input = this.el.nativeElement.querySelector('input');
        this.buildMask(input.value, this.mask);
      }, 200);
    }
  }

  private buildMask(source: string, mask: string) {
    if (source == null || source.trim() == '') {
      return source;
    }
    var result = MaskHelpers.toMask(source, mask);

    if (this.control) {
      this.control.patchValue(result);
    } else {
      const input = this.el.nativeElement.querySelector('input');
      this.renderer2.setProperty(input, 'value', result);
    }
  }
}
